<template>
	<div class="c-axiell-search o-grid" @keyup.enter="runSearch">
		<div class="c-axiell-search__container o-grid__item">
			<div class="c-axiell-search__filter c-axiell-search__filter--advanced"
				v-if="showAdvanced"
			>

				<div class="c-axiell-search__input-name c-form-field--text">
					<label class="c-form-field__legend"> Object name </label>
					<div class="c-form-field__input">
						<input type="text" class="" v-model="objectName" placeholder="Enter object name here..."/>
					</div>
				</div>

				<div class="c-axiell-search__input-description c-form-field--text">
					<label class="c-form-field__legend"> Description </label>
					<div class="c-form-field__input">
						<input type="text" class="" v-model="description" placeholder="Enter description here..." />
					</div>
				</div>

				<div class="c-axiell-search__input-materials c-form-field--text">
					<label class="c-form-field__legend"> Materials </label>
					<div class="c-form-field__input">
						<input type="text" class="" v-model="material" placeholder="Enter materials here..." />
					</div>
				</div>

				<div class="c-axiell-search__input-man c-form-field--text">
					<label class="c-form-field__legend"> Museum reference</label>
					<div class="c-form-field__input">
						<input type="text" class=""  v-model="museumAccessionNumber" placeholder="Enter number here..."  />
					</div>
				</div>

				<div class="c-axiell-search__input-collection c-form-field--text">
					<label class="c-form-field__legend">  Collection</label>
					<div class="c-form-field__input">
						<input type="text" class="" v-model="collection" placeholder="Enter collection here..."/>
					</div>
				</div>

				<div class="c-axiell-search__checkboxes">
					<div class="c-axiell-search__checkbox  c-form-field--checkbox">
						<div class="c-form-field__inputset">
							<label class="c-form-field__input" for="image-checkbox">
								<input id="image-checkbox" type="checkbox" v-model="showImages" />
								<span class="c-form-field__label">Only show results with images</span>
							</label>
						</div>
					</div>
					<div class="c-axiell-search__checkbox c-form-field--checkbox	">
						<div class="c-form-field__inputset">
							<label class="c-form-field__input" for="display-checkbox">
								<input id="display-checkbox" type="checkbox" v-model="showOnDisplay" />
								<span class="c-form-field__label">Only show items on display</span>
							</label>
						</div>
					</div>
				</div>

				<button class="c-axiell-search__advanced o-button o-button--secondary" @click.prevent="toggleAdvanced">Back to regular Search</button>
				<div class="c-axiell-search__actions">
					<button class="c-axiell-search__clear o-button o-button o-button--primary-alt" @click.prevent="clearSearch">Clear Search</button>
					<button class="c-axiell-search__submit o-button" @click.prevent="runSearch">Search</button>
				</div>
			</div>
			<div class="c-axiell-search__filter c-axiell-search__filter--simple o-grid__item"
				v-else
			>
				<div class="c-axiell-search__input c-search-field">
					<div class="c-search-field__input c-form-field--text c-form-field--combined">
						<div class="c-form-field__input c-axiell-search__input c-axiell-search__input--combined">
							<input
								class=""
								id="main-search-input"
								type="text"
								v-model="description"
								v-on:keyup.enter="search"
								placeholder="Search our collection..."
								@input="onChangeDebounced"
							/>
							<button @click.prevent="clearSearch(false)" class="c-form-field__append c-form-field__append--faint">
								<span class="icon i-close">
									<close-icon/>
								</span>
							</button>
						</div>
					</div>
					<button class="c-search-field__submit o-button" @click.prevent="runSearch">Search</button>
					<!-- <ul class="c-search-field__autocomplete">
						<li v-for="term in autoCompleteTerms" v-html="term" :key="term" @click="updateDescription(term)"></li>
					</ul> -->
				</div>
				<div class="c-axiell-search__checkboxes">
					<div class="c-axiell-search__checkbox c-form-field--checkbox">
						<div class="c-form-field__inputset">
							<label class="c-form-field__input" for="image-checkbox">
								<input id="image-checkbox" type="checkbox" v-model="showImages" />
								<span class="c-form-field__label">Only show results with images</span>
							</label>
						</div>
					</div>
					<div class="c-axiell-search__checkbox c-form-field--checkbox">
						<div class="c-form-field__inputset">
							<label class="c-form-field__input" for="display-checkbox">
								<input id="display-checkbox" type="checkbox" v-model="showOnDisplay" />
								<span class="c-form-field__label">Only show items on display</span>
							</label>
						</div>
					</div>
				</div>
				<button class="c-axiell-search__advanced o-button o-button--secondary" @click.prevent="toggleAdvanced">Advanced Search</button>
			</div>
		</div>

		<axiell-loading :display-query="readableQuery" v-if="loading">Loading</axiell-loading>

		<div class="c-site-search__results o-grid__item" v-else-if="searchResults">
				<p v-if="error">{{ error }}</p>
				<template v-else>
				<p class="c-site-search__query o-block" v-if="displayHits" v-html="`${displayHits} items found for ${readableQuery}`"></p>

				<ul class="o-grid o-grid--contained o-list" v-if="searchResults">
					<li
						class="o-grid__item o-block--column h-colspan--221"
						v-for="item in searchResults"
						:key="item.priref"
					>
						<a :href="'/search-our-collections/collection-search-results?entry=' + item['@priref']" class="c-media c-media--axiell">
							<div class="c-media__image">
								<div class="o-image">
									<img
									v-if="getImage(item.Media)"
									:src="getImage(item.Media)"
									class="o-image__img"
									width="562"
									height="375"
									alt=""
									loading="lazy"
									style="--object-position: 50% 50%;"
									/>
									<div
										v-else
										class="o-placeholder"
										style="--aspect-ratio: 1.5786516853933"
									></div>
								</div>
							</div>

							<h4
								class="c-media__title"
								v-html="getTitle(item)"
							></h4>
							<!-- <dl class="c-media__meta">
								<div class="c-media__meta-item">
									<dt class="h-text--bold">
										Date:
									</dt>
									<dd class="">
										1815-1829
									</dd>
								</div>
							</dl> -->
							<p
								class="c-media__summary"
								v-html="item.Description[0].description"
							></p>
							<div class="c-media__actions">
								<div class="o-button o-button--secondary">View more details</div>
							</div>
						</a>
					</li>
				</ul>
				<axiell-pagination
						:current-page="currentPage"
						:last-page-number="lastPageNumber"
						@setPage="setPage($event, i)"
						v-if="lastPageNumber > 1"
					>
				</axiell-pagination>
				</template>
		</div>
		<div class="c-site-search___results o-grid__item" v-else>
			<p v-if="error">{{ error }}</p>

			<template v-else>
				<p class="c-site-search__query o-block"  v-if="readableQuery" v-html="(hasQuery ? 'Sorry, we couldn\'t find any objects with ' : '') + readableQuery"></p>

				<p>Try broadening your search or explore one of our collection categories below:</p>
			</template>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import sanitizeHtml from 'sanitize-html';

	import axiellPagination from "./axiell-pagination.vue";
	import axiellLoading from "./axiell-loading.vue";

	import closeIcon from '/web/static/images/svgs/icon-cross.svg?component';

	export default {
		data() {
			return {
				loading: false,
				mode: 'default',

				displayHits: 0,
				currentPage: 1,
				limit: 12,
				queryHasChanged: false,

				objectName: '',
				description: '',
				material: '',
				museumAccessionNumber: '',
				collection: '',
				search: '',

				showAdvanced: false, //toggle for advanced fields
				showImages: false, //toggle for displaying results with images only
				showOnDisplay: false, //toggle for displaying results on display only

				error: null, //error string
				searchResults: null, //array of search results
				searchMeta: {}, //object with search meta

				readableQuery: '',
				autoCompleteTerms: [],
			};
		},
		created() {
			// this.onChangeDebounced = this.debounce(event => {
			// 	console.log('changed value:', event.target.value);
			// 	this.getAutocomplete(event.target.value)
			// }, 1000);
		},
		mounted() {
			this.readQueryParam();

			// axios
			// 	.get(this.apiUrl + '/api/axiell?output=json&database=ChoiceCollect&command=getmetadata&limit=0')
			// 	.then((response) => {
			// 		console.log(response);
			// 	})
			// 	.catch((error) => {
			// 		console.log(error);

			// 		return "Error";
			// 	});
		},
		props: ['apiUrl'],
		components: {axiellPagination, axiellLoading, closeIcon},
		computed: {
			lastPageNumber() {
				return Math.ceil(this.displayHits / this.limit);
			},
			hasQuery() {
				const self = this;

				return (self.description + self.objectName + self.material + self.museumAccessionNumber + self.collection + self.search).length > 0
			},
			searchQuery() {
				const self = this;
				let string = '';

				//(object_name='comb case*' or taxonomy.scientific_name='comb case*' or taxonomy.common_name='comb case*'

				if (self.mode == 'direct') {
					string = self.search;
				}
				else {
					if (self.description) {
						string = string + `${string.length ? ' and ' : ''}description='${self.description}'`;
					}

					if (self.showImages) {
						string = string + `${string.length ? ' and ' : ''}(media.reference->record_access.rights=1)`;
					}

					if (self.showOnDisplay) {
						string = string + `${string.length ? ' and ' : ''}((current_location.name->(location_type=*display* and not term.status=obsolete)) and not location_check.status='absent at audit')`;
					}

					if (self.objectName) {
						string = string + `${string.length ? ' and ' : ''}(object_name='${self.objectName}*' or taxonomy.scientific_name='${self.objectName}*' or taxonomy.common_name='${self.objectName}*')`;
					}

					if (self.material) {
						string = string + `${string.length ? ' and ' : ''}material='${self.material}'`;
					}

					if (self.museumAccessionNumber) {
						string = string + `${string.length ? ' and ' : ''}object_number='${self.museumAccessionNumber}'`;
					}

					if (self.collection) {
						string = string + `${string.length ? ' and ' : ''}collection='${self.collection}'`;
					}
				}

				return string;
			},
			displayQuery() {
				const self = this;
				let string = 'records';
				let multiple = false;

				if (!self.hasQuery) {
					string = 'Please enter some search terms'
				}
				else {
					if (self.description) {
						string = string + `${multiple ? ' and' : ' with'} a description containing <i>${self.description}</i>`;
						multiple = true;
					}

					if (self.objectName) {
						string = string + `${multiple ? ' and' : ' with'} a name containing <i>${self.objectName}</i>`;
						multiple = true;
					}

					if (self.material) {
						string = string + `${multiple ? ' and' : ' with'} a material of <i>${self.material}</i>`;
						multiple = true;
					}

					if (self.museumAccessionNumber) {
						string = string + `${multiple ? ' and' : ' with'} a museum reference of <i>${self.museumAccessionNumber}</i>`;
						multiple = true;
					}

					if (self.collection) {
						string = string + `${multiple ? ' and' : ''} in a collection containing <i>${self.collection}</i>`;
						multiple = true;
					}

					if (self.showImages) {
						if (self.showOnDisplay) {
							string = string + ` that have images and are on display`;
						} else {
							string = string + ` that have images`;
						}
					}
					else if (self.showOnDisplay) {
						string = string + ` that are on display`;
					}
				}

				return sanitizeHtml(string);
			}
		},
		methods: {
			debounce(func, timeout = 300){
				let timer;
				return (...args) => {
					clearTimeout(timer);
					timer = setTimeout(() => { func.apply(this, args); }, timeout);
				};
			},
			buildQuery() {
				const self = this;
				const startFrom = (self.currentPage - 1) * self.limit + 1;
				return (
					self.apiUrl +
					`/api/axiell?output=json&database=ChoiceCollect&search=(${encodeURIComponent(self.searchQuery)})&limit=${self.limit}&startfrom=${startFrom}`
				);
			},
			updateDescription(value) {
				// console.log(value, this.description)
				this.description = value ? value : this.description;
				// console.log(value, this.description)
			},
			getTitle(item) {
				if (item.Object_name) {
					let firstName = item.Object_name.find((element) => element.object_name.term);

					if (firstName) {
						return firstName.object_name.term[0]
					}				
				} else if (item.Taxonomy) {
					return item.Taxonomy[0]['taxonomy.scientific_name'].scientific_name[0]
				}
			},
			getImage(param) {
				const self = this;
				// console.log('param', param)
				if (param) {
					//loop through param, find first object with media reference
					let id = null;
					const mediaObject = param.find((element) => element['media.reference'].reference_number);

					if(mediaObject) {
						id = mediaObject['media.reference'].reference_number;
					}

					if (id) {
						return (
							self.apiUrl +
							`/api/axiell?output=json&command=getcontent&server=Detail&width=310&height=285&scalemode=fill&imageformat=png&canvascolor=transparent&value=${id}`
						);
					} else {
						return false;
					}
				} else {
					return false
				}
			},
			getData() {
				const self = this;

				self.loading = true;
				self.error = null;

				if(self.queryHasChanged) {
					self.currentPage = 1;
				}

				self.updateQueryParam(self.currentPage);


				//we only want to update the readable query on search, so we do it this way
				self.readableQuery = self.displayQuery;

				// console.log('get data',self.hasQuery)

				if (self.hasQuery) {
					axios({
						method: 'GET',
						url: self.buildQuery(),
						timeout: 30000, //30 second timeout for requests
						signal: AbortSignal.timeout(30000), //30 second timeout for connections
					})
					.then((response) => {
						// console.log(response);

						self.searchResults = response.data.adlibJSON.recordList;
						self.searchMeta = response.data.adlibJSON.diagnostic;
						self.displayQuery = self.query;
						self.displayHits = self.searchMeta.hits;

						if (self.searchMeta.error) {
							self.error = self.searchMeta.error.message;
							return "Error";
						}
					})
					.catch((error) => {
						if (error.code == "ECONNABORTED") {
							self.error = "That request has timed out, please try again later"
						} else {
							self.error = "An issue has occurred, please try again later"
						}

					}).finally(()=> {
						self.loading = false
					});
				} else {
					self.loading = false;
					self.error = null;

					self.readableQuery = self.displayQuery
				}
			},
			runSearch() {
				this.getData();
			},
			clearSearch(checkboxes = true) {
				this.currentPage = 1;
				this.searchResults = null;

				this.objectName = '';
				this.description = '';
				this.material = '';
				this.museumAccessionNumber = '';
				this.collection = '';

				if(checkboxes) {
					this.showImages = false;
					this.showOnDisplay = false;
				}

				// clear readableQuery
				this.readableQuery = '';
			},
			toggleAdvanced() {
				this.showAdvanced = !this.showAdvanced;
				//this.clearSearch();

				this.$store.dispatch("changeAdvancedSearch", this.showAdvanced);
			},
			updateQueryParam(page) {
				const self = this;
				const searchParams = new URLSearchParams(window.location.search);

				searchParams.set("description", self.description);
				searchParams.set("showImages", self.showImages);
				searchParams.set("showDisplay", self.showOnDisplay);
				searchParams.set("page", page);

				if (self.showAdvanced) {
					searchParams.set("advanced", self.showAdvanced);

					if (self.objectName) {
						searchParams.set("objectName", self.objectName);
					}
					else {
						searchParams.delete("objectName");
					}

					if (self.material) {
						searchParams.set("material", self.material);
					}
					else {
						searchParams.delete("material");
					}

					if (self.museumAccessionNumber) {
						searchParams.set("museumAccessionNumber", self.museumAccessionNumber);
					}
					else {
						searchParams.delete("museumAccessionNumber");
					}

					if (self.collection) {
						searchParams.set("collection", self.collection);
					}
					else {
						searchParams.delete("collection");
					}

				} else {
					searchParams.delete("advanced");

					searchParams.delete("objectName");
					searchParams.delete("material");
					searchParams.delete("museumAccessionNumber");
					searchParams.delete("collection");

					self.objectName = '';
					self.material = ''
					self.museumAccessionNumber = ''
					self.collection = ''
				}

				history.replaceState(null, null, "?" + searchParams.toString());
			},
			hilightSearch(string) {
				const self = this;
				const reg = new RegExp(self.query, "gi");
				const hilightedString = string.replace(
					reg,
					'<span style="background-color:yellow;color:black;">$&</span>'
				);

				return hilightedString;
			},
			setPage(i) {
				const self = this;

				self.currentPage = i;

				self.queryHasChanged = false; //we dont want to trigger a query change when navigating pages

				document.getElementById('search').scrollIntoView(true);// scroll to top of search elements, not page
				self.runSearch();
			},
			parseMeta(data) {
				const self = this;

				self.displayHits = data.hits;
			},
			getAutocomplete(value) {
				this.autoCompleteTerms = [];

				if (value) {
					axios
						.get(this.apiUrl + `/api/axiell?output=json&database=ChoiceCollect&autocomplete=BE&value=${value}`)
						.then((response) => {
							// console.log(response);

							let data = response.data.adlibJSON.recordList;

							data.forEach(record => {
								let value = record.term[0]
								if (this.autoCompleteTerms.indexOf(value) === -1) {
									this.autoCompleteTerms.push(value);
								}
							});
						})
						.catch((error) => {
							console.log(error);

							return "Error";
						});
				}
			},
			readQueryParam() {
				const self = this;
				const searchParams = new URLSearchParams(window.location.search);
				let finalSearch = false;

				if (searchParams.get("mode")) {
					self.mode = searchParams.get("mode");
				}

				if (searchParams.get("search")) {
					self.search = searchParams.get("search");
					finalSearch = true;
				}

				if (searchParams.get("page")) {
					self.currentPage = searchParams.get("page");
				}

				if (searchParams.get("description")) {
					self.description = searchParams.get("description");
					finalSearch = true;
				}

				if (searchParams.get("showImages")) {
					// console.log(searchParams.get("showImages"))
					self.showImages = JSON.parse(searchParams.get("showImages")) ;
				}

				if (searchParams.get("showDisplay")) {
					self.showOnDisplay = JSON.parse(searchParams.get("showDisplay"));
				}

				if (searchParams.get("advanced")) {
					self.showAdvanced = searchParams.get("advanced");

					if (searchParams.get("material")) {
						self.material = searchParams.get("material");
						finalSearch = true;
					}

					if (searchParams.get("objectName")) {
						self.objectName = searchParams.get("objectName");
						finalSearch = true;
					}

					if (searchParams.get("museumAccessionNumber")) {
						self.museumAccessionNumber = searchParams.get("museumAccessionNumber");
						finalSearch = true;
					}

					if (searchParams.get("collection")) {
						self.collection = searchParams.get("collection");
						finalSearch = true;
					}
				}

				self.queryHasChanged = false; //we dont want to trigger a query change when updating the search query from the url

				if (finalSearch) {
					self.runSearch();
				}
			},
		},
		watch: {
			searchQuery(newVal, oldVal) {
				const self = this;

				self.queryHasChanged = true;
			}
		}
	};
</script>

